interface BrowserCompatibility {
  isCompatible: boolean;
  missingFeatures: string[];
  userAgent: string;
  isTablet: boolean;
  isMobile: boolean;
}

export function checkBrowserCompatibility(): BrowserCompatibility {
  const missingFeatures: string[] = [];
  const userAgent = navigator.userAgent;
  
  // Check for tablet/mobile
  const isTablet = /iPad|Android(?!.*Mobile)|Tablet/i.test(userAgent);
  const isMobile = /iPhone|iPod|Android.*Mobile/i.test(userAgent);
  
  // Check required browser features
  if (!window.crypto || !window.crypto.getRandomValues) {
    missingFeatures.push('Web Crypto API (getRandomValues)');
  }
  
  if (!window.crypto || !window.crypto.subtle) {
    missingFeatures.push('Web Crypto API (subtle)');
  }
  
  if (!window.localStorage) {
    missingFeatures.push('localStorage');
  }
  
  if (!window.sessionStorage) {
    missingFeatures.push('sessionStorage');
  }
  
  if (!window.Promise) {
    missingFeatures.push('Promise support');
  }
  
  if (!window.fetch) {
    missingFeatures.push('Fetch API');
  }
  
  // Check for service worker support (required for PWA)
  if (!('serviceWorker' in navigator)) {
    missingFeatures.push('Service Worker support');
  }
  
  // Check for IndexedDB (used by Redux persist)
  if (!window.indexedDB) {
    missingFeatures.push('IndexedDB');
  }
  
  return {
    isCompatible: missingFeatures.length === 0,
    missingFeatures,
    userAgent,
    isTablet,
    isMobile,
  };
}

export function getBrowserInfo() {
  const ua = navigator.userAgent;
  let browserName = 'Unknown';
  let browserVersion = 'Unknown';
  
  if (ua.includes('Chrome/')) {
    browserName = 'Chrome';
    browserVersion = ua.match(/Chrome\/(\d+)/)?.[1] || 'Unknown';
  } else if (ua.includes('Safari/') && !ua.includes('Chrome')) {
    browserName = 'Safari';
    browserVersion = ua.match(/Version\/(\d+)/)?.[1] || 'Unknown';
  } else if (ua.includes('Firefox/')) {
    browserName = 'Firefox';
    browserVersion = ua.match(/Firefox\/(\d+)/)?.[1] || 'Unknown';
  } else if (ua.includes('Edge/')) {
    browserName = 'Edge';
    browserVersion = ua.match(/Edge\/(\d+)/)?.[1] || 'Unknown';
  }
  
  return { browserName, browserVersion };
}